import(/* webpackMode: "eager" */ "/home/runner/workspace/artifacts/light-hero/app/global-error.tsx");
